import { api } from "../api";

/**
 * findAllGeofencesExportResponse - Function that finds on database all geofences by department and status and then exports in a PDF/XSLX file  
 * /geofences/{customerId}/{departmentId}/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const findAllGeofencesExportResponse = async (token: string, customerId: number, departmentId: number, status: string, exportType: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/geofences/${customerId}/${departmentId}/${status}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllGeofencesExportResponse;